<template>
  <a-modal
  :maskClosable="false"
    title="添加用户"
    visible
    :confirm-loading="confirmAddLoading"
    @ok="handleAddOk"
    destroyOnClose
    @cancel="$emit('complete')"
  >
    <ak-inputs v-model="formdata" :options="options" ref="inputs" />
    <div class="-translate-y-full">*默认密码{{ defaultPass }}</div>
    <div class="m-b-5">状态</div>
    <a-radio-group name="radioGroup" v-model="status">
      <a-radio value="enabled">
        启用
      </a-radio>
      <a-radio value="disabled">
        禁用
      </a-radio>
    </a-radio-group>
  </a-modal>
</template>
<script>
import { notEmpty, isPhone } from '../../utils/validator.js'
import { mapGetters } from 'vuex'

export default {
  props: {
    record: Object, // 当前行的数据
    vm: Object, // 触发这个action的组件对象，通常为modelTable或modelTree
    fields: Array, // 当前model的fields对象
    model: Object, // 当前model对象
    className: String, // 当前model的className
    modelName: String, // 当前model的名称
    category: String // 假如当前model显示为category格式，则会将当前的值传入
  },
  data () {
    return {
      defaultPass: 'zhlc123',
      confirmAddLoading: false,
      formdata: {},
      status: 'enabled',
      options: [
        {
          name: 'hierarchy',
          note: '所属层级',
          type: 'Pointer',
          validators: [notEmpty()],
          span: 24,
          targetClass: 'hierarchy',
          searchKey: ['name'],
          listWhere: (where) => {
            where.tag = {
              $regex: `^${this.userLevelTag}`
            }
          }
        },
        {
          name: 'nickName',
          note: '姓名',
          type: 'String',
          validators: [notEmpty()]
        },
        {
          name: 'phone',
          note: '手机号',
          type: 'String',
          validators: [notEmpty(), isPhone()]
        },
        {
          name: 'username',
          note: '账号',
          type: 'String',
          validators: [notEmpty()]
        },
        {
          name: 'userType',
          note: '用户类型',
          type: 'Select',
          validators: [notEmpty()],
          items: {
            level: '层级管理员',
            warehouse: '粮库管理员'
          }
        }
      ]
    }
  },
  methods: {
    async handleAddOk () {
      const error = await this.$refs.inputs.validate()
      if (Object.keys(error).length > 0) {
        return
      }
      this.$loading.show()
      this.confirmAddLoading = true
      try {
        const data = {
          hierarchy: this.formdata.hierarchy,
          nickName: this.formdata.nickName,
          phone: this.formdata.phone,
          username: this.formdata.username,
          userType: this.formdata.userType,
          password: this.defaultPass,
          status: this.status
        }
        await this.$tkParse.post('/classes/_User', data)
        this.vm.refresh()
        this.visible = false
        this.$notification['success']({
          message: '操作成功',
          description: '数据保存成功'
        })
        this.$emit('complete')
      } catch (e) {
        console.log(e)
        this.$notification['error']({
          message: '操作失败',
          description: '操作失败，请重试'
        })
      }
      this.confirmAddLoading = false
      this.$loading.hide()
    },
    handleAddCancel () {
      this.visible = false
    }
  },
  computed: {
    ...mapGetters(['userLevelTag'])
  }
}
</script>
<style></style>
